<template>
  <CBox data-cy="text-tile">
    <OmtTypography :as="as" mb="4px" :color="color"> {{ title }} </OmtTypography>
    <OmtTypography as="p1"> {{ description }} </OmtTypography>
  </CBox>
</template>

<script>
/**
 * @prop { String } title
 * @prop { String } description
 */

export default {
  props: {
    title: String,
    description: String,
    color: {
      type: String,
      default: "var(--colors-light-primary-gray2)"
    },
    as: {
      type: String,
      default: "p2"
    }
  }
};
</script>
